import { render, staticRenderFns } from "./PrintQr.vue?vue&type=template&id=6064f988&scoped=true"
import script from "./PrintQr.vue?vue&type=script&lang=js"
export * from "./PrintQr.vue?vue&type=script&lang=js"
import style0 from "./PrintQr.vue?vue&type=style&index=0&id=6064f988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064f988",
  null
  
)

export default component.exports